import { render, staticRenderFns } from "./InvoiceManager.vue?vue&type=template&id=b7119e4e"
import script from "./InvoiceManager.vue?vue&type=script&lang=js"
export * from "./InvoiceManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports